import { Auth } from 'aws-amplify'
import config from '~/config'
import { TOKEN_UNAVAILABLE_MESSAGE } from '~/helpers/axiosAuth'

export default ({ store, redirect, route, error, app }) => {
  if (store.state.accessTokenStatus === 'unavailable') {
    // トークンが一時的に取れないだけ(通信失敗など)なので、サインアウトしない。
    // 既存のトークンがあればそのまま進む(API 側はヘッダー無し + 印付きで送られ、401 でもログアウトされない)
    if (store.state.accessToken) {
      return
    }
    // 既存のトークンも無い(初回読み込みなど)。ログイン画面へ飛ばさず、通信失敗の案内で止める(再読込で復帰できる)
    error({ statusCode: 400, message: TOKEN_UNAVAILABLE_MESSAGE })
    return
  }
  if (!store.state.accessToken) {
    // ここの signOut は同一サイトの localStorage を全タブ共通で消す。別タブで操作中の利用者のセッションが
    // 消える経路になり得るため、理由付きで Sentry に残す(session-lost 通知との突き合わせ用)
    if (app && app.$authToken && app.$authToken.reportSignOut) {
      app.$authToken.reportSignOut('middleware-no-token', {
        path: route && route.fullPath,
        hadToken: !!store.state.accessToken,
        tokenStatus: store.state.accessTokenStatus
      })
    }
    Auth.signOut()
    localStorage.setItem(config.redirectKey, route.fullPath)
    redirect('/login')
  }
}
